// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cookie Consent Component Styles */
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(31, 41, 55, 0.95);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(16px);
          backdrop-filter: blur(16px);
  z-index: 1000;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
}

.cookie-banner.show {
  transform: translateY(0);
}

.cookie-banner-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.cookie-banner-text {
  flex: 1;
}

.cookie-banner-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #f9fafb;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Inter', sans-serif;
}

.cookie-banner-title i {
  color: #8b5cf6;
}

.cookie-banner-description {
  color: #d1d5db;
  line-height: 1.6;
  margin: 0;
}

.cookie-link {
  color: #8b5cf6;
  text-decoration: none;
  font-weight: 500;
}

.cookie-link:hover {
  text-decoration: underline;
}

.cookie-banner-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.cookie-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;
  white-space: nowrap;
}

.btn-primary {
  background: #8b5cf6;
  color: white;
}

.btn-primary:hover {
  background: #7c3aed;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.btn-secondary {
  background: #374151;
  color: #f9fafb;
}

.btn-secondary:hover {
  background: #4b5563;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-outline {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #f9fafb;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cookie-banner-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.cookie-banner-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f9fafb;
}

/* Cookie Modal Styles */
.cookie-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.cookie-modal.show {
  opacity: 1;
  visibility: visible;
}

.cookie-modal-content {
  background: #1f2937;
  border-radius: 0.5rem;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.cookie-modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cookie-modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #f9fafb;
  margin: 0;
  font-family: 'Inter', sans-serif;
}

.cookie-modal-close {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.cookie-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f9fafb;
}

.cookie-modal-body {
  padding: 1.5rem;
}

.cookie-category {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.cookie-category:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.cookie-category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.cookie-category h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #f9fafb;
  margin: 0;
  font-family: 'Inter', sans-serif;
}

.cookie-category-description {
  color: #d1d5db;
  line-height: 1.6;
  margin: 0;
}

/* Cookie Toggle Styles */
.cookie-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  cursor: pointer;
}

.cookie-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.cookie-toggle-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #374151;
  border-radius: 24px;
  transition: 0.3s;
}

.cookie-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
}

.cookie-toggle input:checked + .cookie-toggle-slider {
  background: #8b5cf6;
}

.cookie-toggle input:checked + .cookie-toggle-slider:before {
  transform: translateX(26px);
}

.cookie-toggle input:disabled {
  cursor: not-allowed;
}

.cookie-toggle input:disabled + .cookie-toggle-slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.cookie-modal-footer {
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

/* Responsive Design */
@media (max-width: 768px) {
  .cookie-banner-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .cookie-banner-actions {
    flex-direction: column;
    width: 100%;
  }

  .cookie-btn {
    width: 100%;
    justify-content: center;
  }

  .cookie-banner-close {
    position: static;
    align-self: flex-end;
    margin-top: 0.5rem;
  }

  .cookie-modal-content {
    margin: 1rem;
    width: calc(100% - 2rem);
  }

  .cookie-modal-footer {
    flex-direction: column;
  }

  .cookie-modal-footer .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .cookie-banner-content {
    padding: 1rem;
  }

  .cookie-banner-title {
    font-size: 1.125rem;
  }

  .cookie-banner-description {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CookieConsent.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,8CAA8C;EAC9C,mCAA2B;UAA3B,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qFAAqF;EACrF,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Cookie Consent Component Styles */\n.cookie-banner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(31, 41, 55, 0.95);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(16px);\n  z-index: 1000;\n  transform: translateY(100%);\n  transition: transform 0.3s ease-in-out;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.cookie-banner.show {\n  transform: translateY(0);\n}\n\n.cookie-banner-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.cookie-banner-text {\n  flex: 1;\n}\n\n.cookie-banner-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #f9fafb;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: 'Inter', sans-serif;\n}\n\n.cookie-banner-title i {\n  color: #8b5cf6;\n}\n\n.cookie-banner-description {\n  color: #d1d5db;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.cookie-link {\n  color: #8b5cf6;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.cookie-link:hover {\n  text-decoration: underline;\n}\n\n.cookie-banner-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.cookie-btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  border: none;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  background: #8b5cf6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #7c3aed;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n.btn-secondary {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.btn-outline {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #f9fafb;\n}\n\n.btn-outline:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.cookie-banner-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease;\n}\n\n.cookie-banner-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f9fafb;\n}\n\n/* Cookie Modal Styles */\n.cookie-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.cookie-modal.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.cookie-modal-content {\n  background: #1f2937;\n  border-radius: 0.5rem;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.cookie-modal-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cookie-modal-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #f9fafb;\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n}\n\n.cookie-modal-close {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease;\n}\n\n.cookie-modal-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f9fafb;\n}\n\n.cookie-modal-body {\n  padding: 1.5rem;\n}\n\n.cookie-category {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.cookie-category:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.cookie-category-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.cookie-category h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #f9fafb;\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n}\n\n.cookie-category-description {\n  color: #d1d5db;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Cookie Toggle Styles */\n.cookie-toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n  cursor: pointer;\n}\n\n.cookie-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.cookie-toggle-slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #374151;\n  border-radius: 24px;\n  transition: 0.3s;\n}\n\n.cookie-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background: white;\n  border-radius: 50%;\n  transition: 0.3s;\n}\n\n.cookie-toggle input:checked + .cookie-toggle-slider {\n  background: #8b5cf6;\n}\n\n.cookie-toggle input:checked + .cookie-toggle-slider:before {\n  transform: translateX(26px);\n}\n\n.cookie-toggle input:disabled {\n  cursor: not-allowed;\n}\n\n.cookie-toggle input:disabled + .cookie-toggle-slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cookie-modal-footer {\n  padding: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .cookie-banner-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .cookie-banner-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .cookie-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .cookie-banner-close {\n    position: static;\n    align-self: flex-end;\n    margin-top: 0.5rem;\n  }\n\n  .cookie-modal-content {\n    margin: 1rem;\n    width: calc(100% - 2rem);\n  }\n\n  .cookie-modal-footer {\n    flex-direction: column;\n  }\n\n  .cookie-modal-footer .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .cookie-banner-content {\n    padding: 1rem;\n  }\n\n  .cookie-banner-title {\n    font-size: 1.125rem;\n  }\n\n  .cookie-banner-description {\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
